export default "__VITE_ASSET__CgllwQ9t__"